export class IndentInventortStockReports {
    categoryName: string;
    productName: string;
    rackName: string;
    quantityIn: number;
    quantityOut: number;
    presentQuantity: number;
}